<template>
  <div>
    <breadcrumbs :home="fermenter.name + ': Move contents to other fermenter'" :disabled="!edit"/>

    <v-card flat width="100%" :loading="init">
      <v-form v-model="valid" ref="form" :disabled="!edit">
        <v-container class="pt-6 px-6 purtrak-scrollable" fluid>

            <v-row dense>
              <v-col cols="6" sm="4" lg="3">
                <date-picker v-model="transaction.date" @change="refresh"/>
              </v-col>
            </v-row>

            <v-row dense>
              <v-col cols="6" sm="3" lg="2">
                <decimal-number-input label="Volume" v-model="transaction.volume" :precision="0" prefix="" suffix="litres" integer
                                      :hint="$number(fermenter.contents.volume) + ' litres'"/>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="6" lg="4">
                <v-autocomplete outlined dense label="Move to" v-model="transaction.destinationFermenterId"
                                no-data-text="No eligible fermenter found" :rules="[fieldRules.required]"
                                :items="validFermenters" item-value="id" item-text="name"
                                :hint="destinationFermenter?$number(fermenter.contents.volume) + ' litres':''" persistent-hint/>
              </v-col>
            </v-row>

            <v-row dense >
              <v-col>
                <v-text-field label="Comments" v-model="transaction.comments" outlined dense counter="255" :rules="[fieldRules.maxLength(255)]"/>
              </v-col>
            </v-row>
          </v-container>
      </v-form>
      <v-divider/>
      <v-card-actions class="px-6">
        <v-switch v-if="transactionId && company.permissions.includes('production.write')"
                  v-model="edit" label="Edit" hide-details class="mt-0" :disabled="dirty"/>
        <v-spacer/>
        <v-btn :plain="edit" color="primary" @click="cancel">{{edit?'Cancel':'Done'}}</v-btn>
        <v-btn v-if="edit" color="primary" :loading="saving" @click="save">Save</v-btn>
      </v-card-actions>
    </v-card>

    <confirm-leave v-model="next"/>
  </div>

</template>

<script>
import {format} from 'date-fns'
import confirmLeave from '@/mixins/confirmLeave'

export default {
  name: 'EquipmentFermentersTransferToFermenter',
  mixins: [confirmLeave],
	props: {
    fermenterId: {type:String,required:false},
    transactionId: {type:String, required:false}
	},
	data() {
		return {
      init: true,
      edit: false,
      fermenter: {name:'',contents:{volume:0}},
      valid:true,
      saving:false,
      fermenters: [],
      transaction: {fermenterId:this.fermenterId, date: format(new Date(), 'yyyy-MM-dd HH:mm:ss'),
                    volume: 0, comments:'', destinationFermenterId:''},
      dirty: false
		}
  },
  computed: {
    company() {
      return this.$store.getters.company;
    },
    validFermenters() {
      return this.fermenters.filter(fermenter => fermenter.id !== this.fermenter.id &&
                                                 fermenter.site?.id === this.fermenter.site?.id);
    },
    destinationFermenter() {
      return this.fermenters.find(fermenter => fermenter.id === this.transaction.destinationFermenterId);
    }
  },
  watch: {
    calculateValue() {
      if (this.calculateValue)
        this.transaction.value = null;
    },
    transaction: {
      handler() {this.dirty = true;},
      immediate: true,
      deep: true
    }
  },
	async created() {
    if (this.transactionId) {
      const results = await this.$apiCall(`query EquipmentFermentersTransferToFermenter($id:ID!) {
                                                fermenterTransferFermenterTransaction(id:$id)  {
                                                   id,fermenterId,date,volume,comments,destinationFermenterId,fermenterId
                                                }
                                              }`,
                                          {id:this.transactionId});
      if (results.error) {
        this.$nextTick(() => this.dirty = false);
        this.$router.back();
        return;
      }
      this.transaction = results.data.fermenterTransferFermenterTransaction;
    }
    await this.refresh();
    if (!this.transactionId) {
      this.edit = true;
      if (this.validFermenters.length) {
        this.transaction.destinationFermenterId = this.validFermenters[0].id;
      }
      this.$nextTick(() => {
        this.$refs.form.validate();
      });
    }
    this.$nextTick(() => this.dirty = false);
    this.init = false;
  },

	methods: {
    async refresh() {
      this.fermenters = [];
      await this.$lazyListLoad(this.fermenters, 'fermenters2', `id,name,site{id},contents(date:"${this.transaction.date}") {volume}`, 100, [{field:'active', comparator:'eq', value:'true'}]);
      this.fermenter = this.fermenters.find(fermenter => fermenter.id === this.transaction.fermenterId);
    },
    cancel() {
      this.$router.back();
    },
		async save() {
      if (this.valid) {
        this.transaction.value = this.calculateValue ? null : this.value;
        this.saving = true;
        const results = await this.$apiCall(`mutation EquipmentFermentersTransferToFermenter($input: FermenterTransferFermenterInput!) {
                                              fermenterTransferFermenterCreate(input:$input) {id}
                                            }`,
                                            {input:this.transaction});
        this.saving = false;
        if (!results.error) {
          this.dirty = false;
          this.$router.back();
          this.$store.commit('setError', {type:'success',message:`${this.transactionId?'Updated':'Created'} move contents to fermenter transaction for ${this.fermenter.name}`});
        }
      }
		}
	}
}
</script>